import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import ArticleIcon from "@mui/icons-material/Article";
import YouTubeIcon from "@mui/icons-material/YouTube";
import GoogleIcon from "@mui/icons-material/Google";
import HistoryIcon from "@mui/icons-material/History";
import ContactsIcon from "@mui/icons-material/Contacts";
import GroupIcon from "@mui/icons-material/Group";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import PolicyIcon from "@mui/icons-material/Policy";
import ImageIcon from "@mui/icons-material/Image";
import LinkIcon from "@mui/icons-material/Link";
import LogoutIcon from "@mui/icons-material/Logout";
import CollectionsIcon from "@mui/icons-material/Collections";
import PushPin from "@mui/icons-material/PushPin";
import { Link } from "react-router-dom";

const MainListItems = (props) => {
	return (
		<React.Fragment>
			<ListItemButton
				component={Link}
				selected={props.module === "News"}
				to="/news/main"
			>
				<ListItemIcon>
					<ArticleIcon />
				</ListItemIcon>
				<ListItemText primary="Article" />
			</ListItemButton>

			<ListItemButton
				component={Link}
				selected={props.module === "Gallery"}
				to="/gallery"
			>
				<ListItemIcon>
					<CollectionsIcon />
				</ListItemIcon>
				<ListItemText primary="Gallery" />
			</ListItemButton>

			<ListItemButton
				component={Link}
				selected={props.module === "Videos"}
				to="/videos"
			>
				<ListItemIcon>
					<YouTubeIcon />
				</ListItemIcon>
				<ListItemText primary="Video" />
			</ListItemButton>

			<ListItemButton
				component={Link}
				selected={props.module === "Google Reviews"}
				to="/reviews"
			>
				<ListItemIcon>
					<GoogleIcon />
				</ListItemIcon>
				<ListItemText primary="Google Reviews" />
			</ListItemButton>

			{(props.company === 1 || props.company === 137) && (
				<ListItemButton
					component={Link}
					selected={props.module === "Recent Sales"}
					to="/recent_sales"
				>
					<ListItemIcon>
						<HistoryIcon />
					</ListItemIcon>
					<ListItemText primary="Recent Sales" />
				</ListItemButton>
			)}

			<ListItemButton
				component={Link}
				selected={props.module === "Featured Listing"}
				to="/featured_listing"
			>
				<ListItemIcon>
					<PushPin />
				</ListItemIcon>
				<ListItemText primary="Featured Listing" />
			</ListItemButton>

			<ListItemButton
				component={Link}
				selected={props.module === "Sold Listing"}
				to="/sold_listing"
			>
				<ListItemIcon>
					<HistoryIcon />
				</ListItemIcon>
				<ListItemText primary="Sold Listing" />
			</ListItemButton>

			<ListItemButton
				component={Link}
				selected={props.module === "Agent of the Month"}
				to="/featured_agent"
			>
				<ListItemIcon>
					<GroupIcon />
				</ListItemIcon>
				<ListItemText primary="Agent of the Month" />
			</ListItemButton>

			<ListItemButton
				component={Link}
				selected={props.module === "About Us"}
				to="/shortcut/aboutus"
			>
				<ListItemIcon>
					<ContactsIcon />
				</ListItemIcon>
				<ListItemText primary="About Us" />
			</ListItemButton>

			{(props.company === 1 || props.company === 137) && (
				<>
					{" "}
					<ListItemButton
						component={Link}
						selected={props.module === "Privacy"}
						to="/shortcut/privacy"
					>
						<ListItemIcon>
							<PrivacyTipIcon />
						</ListItemIcon>
						<ListItemText primary="Privacy" />
					</ListItemButton>
					<ListItemButton
						component={Link}
						selected={props.module === "Legal"}
						to="/shortcut/legal"
					>
						<ListItemIcon>
							<PolicyIcon />
						</ListItemIcon>
						<ListItemText primary="Legal" />
					</ListItemButton>
				</>
			)}

			<ListItemButton
				component={Link}
				selected={props.module === "Header Image"}
				to="/headerimage"
			>
				<ListItemIcon>
					<ImageIcon />
				</ListItemIcon>
				<ListItemText primary="Header Image" />
			</ListItemButton>

			<ListItemButton
				component={Link}
				selected={props.module === "Social Media Link"}
				to="/socialmedialink"
			>
				<ListItemIcon>
					<LinkIcon />
				</ListItemIcon>
				<ListItemText primary="Social Media Link" />
			</ListItemButton>

			{props.company === 1 && (
				<>
					<ListItemButton
						component={Link}
						selected={props.module === "Career"}
						to="/career"
					>
						<ListItemIcon>
							<LinkIcon />
						</ListItemIcon>
						<ListItemText primary="Career" />
					</ListItemButton>

					<ListItemButton
						component={Link}
						selected={props.module === "Developer"}
						to="/developer"
					>
						<ListItemIcon>
							<LinkIcon />
						</ListItemIcon>
						<ListItemText primary="Developer" />
					</ListItemButton>
				</>
			)}

			<ListItemButton onClick={props.logOut}>
				<ListItemIcon>
					<LogoutIcon />
				</ListItemIcon>
				<ListItemText primary="Logout" />
			</ListItemButton>
		</React.Fragment>
	);
};

export default MainListItems;
